import * as rnHttp from './http.service';

import rhinoRegistry from 'rhino/src/core/registry/registry.module';

import httpConfig from './http.config';
import * as withCredentialsInterceptor from './with-credentials.interceptor';

export default angular.module('rhino.core.http', [
  rhinoRegistry,
])
  .config(httpConfig)
  .config(withCredentialsInterceptor.installInterceptorConfig)
  .factory(withCredentialsInterceptor.name, withCredentialsInterceptor.default)
  .factory(rnHttp.name, rnHttp.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/http/http.module.js